import { ApiClient } from "@topline/services/apiService";

export class CountryService {
    static componentName = "countryService";
    static $inject = [ApiClient.componentName];

    constructor(
        protected apiClient: ApiClient
    ) {}

    getCountries() {
        return this.apiClient.getCountries();
    }

    getDefaultCountry() {
        return this.apiClient.getDefaultCountry();
    }

    getCurrencies() {
        return this.apiClient.getCurrencies();
    }
}

angular.module("topline.modules").service(CountryService.componentName, CountryService);